import { render, staticRenderFns } from "./CmaCatalog.vue?vue&type=template&id=3d99cef8&scoped=true&"
import script from "./CmaCatalog.vue?vue&type=script&lang=js&"
export * from "./CmaCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CmaCatalog.vue?vue&type=style&index=0&id=3d99cef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99cef8",
  null
  
)

export default component.exports